export const portalElementId = 'tooltips-portal'

export const TooltipsPortal = () => <div id={portalElementId} />
